module.exports = __webpack_public_path__ + "static/media/raymond.e1f34d82.jpg";